import { render, staticRenderFns } from "./_matchFeedOld.vue?vue&type=template&id=3ee8e81a&lang=pug&"
import script from "./_matchFeedOld.vue?vue&type=script&lang=js&"
export * from "./_matchFeedOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports